// Sebaran.actions.js
import axios from "axios";

export const GET_BATAS_WILAYAH = "GET_BATAS_WILAYAH";
export const GET_SEKOLAH_SEBARAN = "GET_SEKOLAH_SEBARAN";

export function getBatasWilayah() {
  return (dispatch) =>
    axios
      .get(localStorage.getItem("api_base") + "/api/getBatasWilayah")
      .then((response) => {
        dispatch({
          type: GET_BATAS_WILAYAH,
          payload: response.data.data,
        });
      });
}

export function getSekolahSebaran(params = {}) {
  return (dispatch) =>
    axios
      .get(localStorage.getItem("api_base") + "/api/getSekolahSebaran", {
        params,
      })
      .then((response) => {
        dispatch({
          type: GET_SEKOLAH_SEBARAN,
          payload: response.data.data,
        });
      });
}
